import {http} from '@/http/index.js';

async function sendComplaint(girlId) {
  return http.post(`/girls/${girlId}/complaints`);
}

export {sendComplaint};
